<div class="login-container m-auto">
  <div class="card boxshadow">
    <div class="card-header bg-primary text-white d-flex justify-content-center align-items-center">
      <a class="btn" style="border: 1px solid; border-color: white;">Help Information</a>
    </div>
    <div class="card-body">

      <div class="help-intro">
        <p>
          Use the contacts below for help with ICD maintenance, sample document portal access,
          and Bridge application support. Campaign-specific points of contact are listed by
          campaign in the sections that follow.
        </p>
      </div>

      <!-- Helpful Contacts -->
      <div class="help-section">
        <h5 class="help-section-title">Helpful Contacts</h5>
        <div class="col-md-4 px-0 mb-2">
          <label class="form-label">Category</label>
          <ng-select [items]="contactCategories" [clearable]="true" [searchable]="true"
                     placeholder="All categories"
                     (change)="filterColumn(contactsDt, 0, $event)">
          </ng-select>
        </div>
        <table *ngIf="contactsReady" #contactsTable datatable [dtOptions]="dtOptionsContacts" class="row-border hover"></table>
      </div>

      <!-- Campaign Points of Contact -->
      <div class="help-section">
        <h5 class="help-section-title">Campaign Points of Contact</h5>
        <div class="col-md-4 px-0 mb-2">
          <label class="form-label">Campaign</label>
          <ng-select [items]="campaignNames" [clearable]="true" [searchable]="true"
                     placeholder="All campaigns"
                     (change)="filterColumn(campaignDt, 0, $event)">
          </ng-select>
        </div>
        <div *ngIf="!campaignReady" class="text-center py-3">Loading...</div>
        <table *ngIf="campaignReady" #campaignTable datatable [dtOptions]="dtOptionsCampaign" class="row-border hover"></table>
      </div>

      <!-- Commission Analyst Points of Contact -->
      <div class="help-section">
        <h5 class="help-section-title">Commission Analyst Points of Contact</h5>
        <div class="col-md-4 px-0 mb-2">
          <label class="form-label">Campaign</label>
          <ng-select [items]="campaignNames" [clearable]="true" [searchable]="true"
                     placeholder="All campaigns"
                     (change)="filterColumn(commissionDt, 0, $event)">
          </ng-select>
        </div>
        <div *ngIf="!campaignReady" class="text-center py-3">Loading...</div>
        <table *ngIf="campaignReady" #commissionTable datatable [dtOptions]="dtOptionsCommission" class="row-border hover"></table>
      </div>

    </div>
  </div>
</div>
